// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Gglf","obliqueLineWrap":"membershipbadge_obliqueLineWrap__19gSB","obliqueLine":"membershipbadge_obliqueLine__1iQi1"};